var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-css"},[_c('div',{ref:"canvas1",staticClass:"canvas-1"},[_c('p',[_vm._v("我是TEST1")])]),_c('div',{ref:"canvas2",staticClass:"canvas-2"},[_c('p',[_vm._v("我是我是TEST122222")])]),_c('button',{staticClass:"btn",on:{"click":_vm.btnclick}},[_vm._v("生成")])])
}
var staticRenderFns = []

export { render, staticRenderFns }